import { useState, useRef, useEffect } from "react";
import { useSingleton } from "../../hooks/use-singleton";
import { useApi } from "../../hooks/use-api";
import {
  API_MEDIUM_TNPSC,
  API_PARTS_TNPSC,
  API_SUBJECTS,
  API_CHPATER_TN,
  API_LESSON_TN,
  API_UNIT_TN,
  API_COUNT_MCQ,
  API_GET_MCQ_TN,
  API_EVALUATE_TN,
  API_LEARNING_CHALLENGE_UPDATE,
} from "../../utils/api-routes";
import { API_EVALUATE_TNPSC } from "../../utils/api-routes";
import { apiStudentStudys } from "../../utils/api-routes";
import { useSearchParams } from "react-router-dom";

const useHandler = () => {
  const { user, mail, medium: medi } = useSingleton();
  const { get, post } = useApi();
  const [searchParams] = useSearchParams();
  const subject = searchParams.get("subject");
  const chapter = searchParams.get("chapter");
  const medium = searchParams.get("medium");
  const part = searchParams.get("part");
  const unit = searchParams.get("unit");
  const lesson = searchParams.get("lesson");

  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(
    subject ? subject : "",
  );
  const [selectedChapter, setSelectedChapter] = useState(
    chapter ? chapter : "",
  );
  const [selectedMedium, setSelectedMedium] = useState(medium ? medium : "");
  const [selectedPart, setSelectedPart] = useState(part ? part : "");
  const [selectedUnit, setSelectedUnit] = useState(unit ? unit : "");
  const [selectedLesson, setSelectedLesson] = useState(lesson ? lesson : "");
  const [mediums, setMediums] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [markDetails, setMarkDetails] = useState({});
  const [showMarks, setShowMarks] = useState(false);
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectChapters, setSelectedChapters] = useState(
    chapter ? [chapter] : [],
  );
  const [selectLessons, setSelectedLessons] = useState(lesson ? [lesson] : []);
  const [selectedQuestion, setSelectedQuestion] = useState("");

  const [questions, setQuestions] = useState([]);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [parts, setParts] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [units, setUnits] = useState([]);
  const [hidePanals, setHidePanals] = useState(false);
  const [numberOfQuestion, setNumberOfQuestion] = useState([]);
  const [mode, setMode] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showSetupPopup, setShowSetupPopup] = useState(false);
  const [showPaletteModal, setShowPaletteModal] = useState(false);
  const [isReviewMode, setIsReviewMode] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);

  const mediumRef = useRef(null);
  const subjectRef = useRef(null);
  const chapterRef = useRef(null);
  const partRef = useRef(null);
  const unitRef = useRef(null);
  const lessonRef = useRef(null);
  const questionRef = useRef(null);
  const selectedAnswersRef = useRef(selectedAnswers);

  const [panelOpen, setPanelOpen] = useState(true); // Start open

  const isStartEnabled =
    selectedLesson && selectedUnit && selectChapters.length > 0;

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res) {
        const payload = {
          board: res?.data?.data?.board,
          clas: res?.data?.data?.class,
        };
        getMediumDetails(payload);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      console.log("Error on getting user studiesdetails", e);
    }
  };

  const getMediumDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MEDIUM_TNPSC, payload);
      if (res) {
        setMediums(res?.data?.mediums);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getPartDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_PARTS_TNPSC, payload);
      if (res) {
        setParts(res?.data?.parts);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getUnitsDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_UNIT_TN, payload);
      if (res) {
        setUnits(res?.data?.units);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getLessonsDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_LESSON_TN, payload);
      if (res) {
        setLessons(res?.data?.lessons);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getSubjectDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_SUBJECTS, payload);
      if (res) {
        setSubjects(res?.data?.subjects);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getChapterDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_CHPATER_TN, payload);
      if (res) {
        setChapters(res?.data?.chapters);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting chapeter details", e);
    }
  };

  const getNoQuestionsDetails = async () => {
    setIsLoading(true);
    try {
      const res = await get(API_COUNT_MCQ);
      if (res) {
        setNumberOfQuestion(res?.data?.count);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting chapeter details", e);
    }
  };

  useEffect(() => {
    if (!selectedUnit || !user?.data?.class) return;
    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      part: selectedPart,
      medium: medi,
      unit: selectedUnit,
    };

    getChapterDetails(payload);
  }, [selectedUnit]);

  useEffect(() => {
    if (!selectedPart || !user?.data?.class) return;
    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      medium: medi,
      part: selectedPart,
    };

    getUnitsDetails(payload);
  }, [selectedPart]);

  useEffect(() => {
    selectedAnswersRef.current = selectedAnswers;
  }, [selectedAnswers]);

  const getMcqdetails = async () => {
    try {
      const payload = {
        mail,
        board: user?.data?.board,
        clas: user?.data?.class,
        chapter: selectedChapter,
        part: selectedPart,
        medium: medi,
        unit: selectedUnit,
        lesson: selectLessons,
        count: selectedQuestion,
      };
      const res = await post(API_GET_MCQ_TN, payload);
      if (res) {
        setQuestionDetails(res?.data);
        setPanelOpen(true);
      }
    } catch (e) {
      console.log("getting error from get mcq details", e);
      const status = e?.response?.status;

      if (status === 403) {
        setHidePanals(false);
        setIsQuizActive(false);
        setQuestionDetails([]);
      }
    }
  };

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  useEffect(() => {
    getNoQuestionsDetails();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        partRef.current?.contains(e.target) ||
        unitRef.current?.contains(e.target) ||
        lessonRef.current?.contains(e.target) ||
        mediumRef.current?.contains(e.target) ||
        subjectRef.current?.contains(e.target) ||
        chapterRef.current?.contains(e.target) ||
        questionRef.current?.contains(e.target)
      )
        return;

      setOpenDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onStartQuiz = () => {
    setCurrentQIndex(0);
    getMcqdetails();
  };

  useEffect(() => {
    if (!medi || !user?.data?.class) return;
    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      medium: medi,
    };

    // getSubjectDetails(payload)
    getPartDetails(payload);
  }, [user, medi]);

  useEffect(() => {
    if (!selectedSubject || !user?.data?.class) return;

    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      medium: medi,
      part: selectedPart,
    };
    // getChapterDetails(payload);
    getUnitsDetails(payload);
  }, [selectedSubject]);

  const normalizeQuestions = (apiData = []) =>
    apiData.map((q) => ({
      question: q["QUESTION"],
      options: [q["OPTION A"], q["OPTION B"], q["OPTION C"], q["OPTION D"]],
      answer: q["ANSWER"],
      questionId: q["QUESTION_ID"],
    }));

  const currentQuestion = questions[currentQIndex];

  useEffect(() => {
    if (questionDetails?.length) {
      const formatted = normalizeQuestions(questionDetails);
      setQuestions(formatted);
    }
  }, [questionDetails]);

  const handleOptionSelect = (index, qIndex) => {
    const targetIdx = qIndex !== undefined ? qIndex : currentQIndex;
    if (!mode && selectedAnswers[targetIdx] !== undefined) return;
    setSelectedAnswers((prev) => ({
      ...prev,
      [targetIdx]: index,
    }));
  };

  const selectedOption = selectedAnswers[currentQIndex];

  const handleNext = () => {
    if (currentQIndex < questions.length - 1) {
      setCurrentQIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQIndex > 0) {
      setCurrentQIndex((prev) => prev - 1);
    }
  };

  const answerdQuestions = Object.keys(selectedAnswers).length;

  const learningChallengeProgress = async () => {
    const attempted = Object.keys(selectedAnswers).length;
    if (attempted <= 0) return;

    const payload = {
      email: mail,
      action_type: "quiz",
      watch_percentage: 100,
      questions_attempted: attempted,
      study_minutes: 0,
    };
    try {
      const res = await post(API_LEARNING_CHALLENGE_UPDATE, payload);
      if (res) {
        console.log(res);
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING CHALLANGE API", e);
    }
  };

  const buildSubmitPayload = () => {
    return questions
      .map((q, index) => {
        // const selectedIndex = selectedAnswers[index];
        const selectedIndex = selectedAnswersRef.current[index];

        // // Skip unattempted questions
        // if (selectedIndex === undefined) return null;

        return {
          QUESTION: q.question,
          ANSWER: selectedIndex !== undefined ? q.options[selectedIndex] : "",
          LESSON: selectedLesson,
          // CHAPTER: selectedChapter,
          QUESTION_ID: q.questionId || "",
        };
      })
      .filter(Boolean); // remove nulls
  };

  useEffect(() => {
    if (!selectedChapter || !user?.data?.class) return;

    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      part: selectedPart,
      medium: medi,
      unit: selectedUnit,
      chapter: selectedChapter,
    };
    getLessonsDetails(payload);
  }, [selectedChapter]);

  const onSubmitQuiz = async () => {
    const payload = buildSubmitPayload();
    const formattedPayload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      // subject: selectedSubject,
      part: selectedPart,
      medium: medi,
      unit: selectedUnit,
      // lesson: selectedLesson,
      lesson: selectLessons,
      chapter: selectedChapter,
      mail,
      answers: payload,
    };
    setShowMarks(true);
    setSubmitLoading(true);
    try {
      const res = await post(API_EVALUATE_TN, formattedPayload);
      if (res) {
        console.log(res?.data, "res");
        setMarkDetails(res?.data);
        localStorage.setItem("marks", res?.data);
        setSubmitLoading(false);
        await learningChallengeProgress();
      }
    } catch (e) {
      console.log("Error on submitquiz details", e);
      setSubmitLoading(false);
    }
  };

  const isAnswered = selectedOption !== undefined;

  const isCorrect =
    isAnswered &&
    currentQuestion?.options[selectedOption] === currentQuestion?.answer;

  const onCancel = () => {
    setIsQuizActive(false);
    setShowMarks(false);
    setMarkDetails({});
    setQuestionDetails([]);
    setSelectedSubject("");
    setSelectedChapter("");
    setSelectedChapters([]);
    setSelectedAnswers({});
    setCurrentQIndex(0);
    setSelectedPart("");
    setSelectedLessons([]);
    setSelectedChapters([]);
    setSelectedChapter("");
    setSelectedQuestion("");
    setHidePanals(false);
    setIsReviewMode(false);
    setQuestions([]);
    setSubmitLoading(false);
    setTimeRemaining(0);
  };

  const resetQuizState = () => {
    setIsQuizActive(true);
    setShowMarks(false);
    setIsReviewMode(false);
    setMarkDetails({});
    setSelectedAnswers({});
    setCurrentQIndex(0);
    setHidePanals(true);
    setPanelOpen(true);
    setSubmitLoading(false);
  };

  const onRetakeQuiz = async () => {
    resetQuizState();

    // Option 1: reuse already fetched questions
    if (questionDetails?.length) {
      const formatted = normalizeQuestions(questionDetails);
      setQuestions(formatted);
      return;
    }

    // Option 2: re-fetch questions from API (recommended)
    // await getMcqdetails();
  };

  const getQuizDuration = (selectLessons, questionCount) => {
    // if (questionCount <= 10) return 10 * 60;   // 10 min
    // if (questionCount <= 20) return 15 * 60;   // 15 min
    // if (questionCount <= 25) return 20 * 60;   // 20 min
    // return 25 * 60; // fallback if more questions in future
    // return questionCount * 60;
    // if (!selectLessons || selectLessons?.length === 0) return 0;

    // // check if "All Lessons" is selected
    // if (
    //   selectLessons?.includes("All Lessons") ||
    //   selectLessons?.includes("அனைத்து பாடங்கள்") ||
    //   selectLessons?.length > 1
    // ) {
    //   return 25 * 60; // 25 minutes
    // }

    // return 10 * 60; // 10 minutes

    if (!questionCount || questionCount <= 0) return 0;

    return questionCount * 60; // 1 question = 1 minute
  };

  const onToggleQuizBtn = () => {
    setMode((p) => !p);
    // setSelectedPart("");
    // setSelectedUnit("");
    // setSelectedSubject("");
    // setSelectedQuestion("");
    // setSelectedLessons([]);
  };

  const getQuestionStatus = (index) => {
    if (index === currentQIndex) return "current";

    if (selectedAnswers[index] !== undefined) {
      return "answered";
    }

    if (index < currentQIndex) {
      return "not-answered";
    }

    return "not-visited";
  };

  return {
    user,
    subjectRef,
    chapterRef,
    openDropdown,
    selectedChapter,
    selectedSubject,
    panelOpen,
    subjects,
    chapters,
    isStartEnabled,
    questionDetails,
    currentQuestion,
    selectedOption,
    questions,
    currentQIndex,
    isAnswered,
    isCorrect,
    markDetails,
    showMarks,
    setShowMarks,
    isQuizActive,
    isLoading,
    selectChapters,
    mediums,
    mediumRef,
    selectedMedium,
    selectLessons,
    hidePanals,
    mode,
    selectedQuestion,
    numberOfQuestion,
    selectedQuestion,
    selectedAnswers,
    submitLoading,
    timeRemaining,
    setTimeRemaining,
    setCurrentQIndex,
    setSelectedQuestion,
    setSelectedChapters,
    onCancel,
    setPanelOpen,
    setOpenDropdown,
    setSelectedChapter,
    setSelectedSubject,
    onStartQuiz,
    handleNext,
    handlePrevious,
    handleOptionSelect,
    onSubmitQuiz,
    onRetakeQuiz,
    setIsQuizActive,
    getQuizDuration,
    setSelectedMedium,
    setSelectedLesson,
    setSelectedPart,
    setSelectedUnit,
    setSelectedLessons,
    setHidePanals,
    onToggleQuizBtn,
    getQuestionStatus,
    partRef,
    lessonRef,
    unitRef,
    questionRef,
    parts,
    lessons,
    units,
    selectedLesson,
    selectedPart,
    selectedUnit,
    showSetupPopup,
    setShowSetupPopup,
    showPaletteModal,
    setShowPaletteModal,
    isReviewMode,
    setIsReviewMode,
  };
};

export default useHandler;
